import React from "react";
import { ArrowLeftRight, Sparkles, Target, Trophy } from "lucide-react";
import { P2P_TERMS } from "../../utils/p2pHelpers";
import { P2P_PLATFORM_FEE_PERCENT } from "../../config/fees";

const STEPS = [
  {
    icon: Target,
    title: "Creator backs",
    desc: "Locks the outcome they believe will land.",
  },
  {
    icon: ArrowLeftRight,
    title: "You bet against",
    desc: "Choose your stake (at or above the min) on the against side.",
  },
  {
    icon: Trophy,
    title: "Result settles",
    desc: `Backing or against side wins. A ${P2P_PLATFORM_FEE_PERCENT}% fee is taken from the winner’s profit.`,
  },
];

const P2PHowItWorks = () => (
  <div className="p2p-primer">
    <div className="p2p-primer-glow" aria-hidden />
    <header className="p2p-primer-head">
      <span className="p2p-primer-icon" aria-hidden>
        <Sparkles size={12} />
      </span>
      <p className="p2p-primer-title">How P2P works</p>
    </header>

    <div className="p2p-primer-duel" aria-hidden>
      <div className="p2p-primer-side p2p-primer-side-creator">
        <span className="p2p-primer-side-tag">Creator</span>
        <span className="p2p-primer-side-action">{P2P_TERMS.backingTag}</span>
      </div>
      <div className="p2p-primer-vs">
        <span className="p2p-primer-vs-line" />
        <span className="p2p-primer-vs-badge">VS</span>
        <span className="p2p-primer-vs-line" />
      </div>
      <div className="p2p-primer-side p2p-primer-side-joiner">
        <span className="p2p-primer-side-tag">You</span>
        <span className="p2p-primer-side-action">{P2P_TERMS.againstTag}</span>
      </div>
    </div>

    <ol className="p2p-primer-steps">
      {STEPS.map(({ icon: Icon, title, desc }, index) => (
        <li key={title} className="p2p-primer-step">
          <div className="p2p-primer-step-rail">
            <span className="p2p-primer-step-node">
              <Icon size={11} aria-hidden />
            </span>
            {index < STEPS.length - 1 && (
              <span className="p2p-primer-step-line" aria-hidden />
            )}
          </div>
          <div className="p2p-primer-step-body">
            <p className="p2p-primer-step-title">{title}</p>
            <p className="p2p-primer-step-desc">{desc}</p>
          </div>
        </li>
      ))}
    </ol>
  </div>
);

export default P2PHowItWorks;
